import * as ActionType from 'constants/action-types/gimac';

export default (state, { type, payload }) => {
  switch (type) {
    case ActionType.GIMAC_TRANSFER_MONEY_START:
      return {
        ...state,
        transferMoney: {
          ...state.transferMoney,
          loading: true,
          error: null,
        },
      };
    case ActionType.GIMAC_TRANSFER_MONEY_SUCCESS:
      return {
        ...state,
        transferMoney: {
          ...state.transferMoney,
          data: payload,
          error: null,
          loading: false,
        },
      };
    case ActionType.GIMAC_TRANSFER_MONEY_FAILURE:
      return {
        ...state,
        transferMoney: {
          ...state.transferMoney,
          data: payload,
          error: null,
          loading: false,
        },
      };
    case ActionType.GIMAC_TRANSFER_MONEY_CLEAR:
      return {
        ...state,
        transferMoney: {
          ...state.transferMoney,
          data: null,
          error: null,
          loading: false,
        },
        transferConfirmation: {
          ...state.transferConfirmation,
          data: null,
          error: null,
          loading: false,
        },
      };
    default:
      return null;
  }
};
